customElements.define('component-card-image', class CardImage extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const template = document.getElementById('js-card-image-template');
    this.appendChild(template.content.cloneNode(true));

    // Properties
    this.image = this.getAttribute('image') || '';
    this.pictureHtml = this.pictureHtml || this.getAttribute('pictureHtml') || '';
    this.imageAlt = this.getAttribute('imageAlt') || '';
    this.link = this.getAttribute('link') || '#';
    this.heading = this.getAttribute('heading') || '';
    this.ctaText = this.getAttribute('ctaText') || 'Shop now';
    if (window.Shopify.country === 'CA') {
      if (this.getAttribute('imageCA')) this.image = this.getAttribute('imageCA');
      if (this.pictureHtmlCA || this.getAttribute('pictureHtmlCA')) {
        this.pictureHtml = this.pictureHtmlCA || this.getAttribute('pictureHtmlCA');
      }
      if (this.getAttribute('imageAltCA')) this.imageAlt = this.getAttribute('imageAltCA');
      if (this.getAttribute('linkCA')) this.link = this.getAttribute('linkCA');
      if (this.getAttribute('headingCA')) this.heading = this.getAttribute('headingCA');
      if (this.getAttribute('ctaTextCA')) this.ctaText = this.getAttribute('ctaTextCA') || 'Shop now';
    }

    // DOM elements
    this.cardImageLink = this.querySelector('#card-image-link');
    this.cardImageContainer = this.querySelector('.card-image');
    this.cardTitle = this.querySelector('.card-image-title');
    this.cardCta = this.querySelector('.card-image-cta');

    // Init
    // In case the URL doesn't include de domain
    if (!(/^https?:\/\//ig).test(this.link)) {
      this.baseUrlSplit = window.location.host.split('.');
      this.baseUrlSplit.shift();
      this.baseUrl = this.baseUrlSplit.join('.');
      this.link = `https://www.${this.baseUrl}${this.link}`;
    }

    this.cardImageLink.href = this.link;

    if (this.pictureHtml) {
      const parsedDocument = new DOMParser().parseFromString(String(this.pictureHtml), 'text/html');
      const safeImageNode = parsedDocument.querySelector('picture, img');

      if (safeImageNode) {
        safeImageNode.querySelectorAll('script, iframe, object, embed, link, style').forEach((element) => {
          element.remove();
        });

        [safeImageNode, ...safeImageNode.querySelectorAll('*')].forEach((element) => {
          [...element.attributes].forEach(({ name, value }) => {
            if (/^on/i.test(name) || /javascript:/i.test(value)) {
              element.removeAttribute(name);
            }
          });
        });

        this.cardImageContainer.appendChild(document.importNode(safeImageNode, true));
      }

      const pictureImgElement = this.cardImageContainer.querySelector('img');
      if (pictureImgElement) {
        if (!pictureImgElement.getAttribute('src') && this.image) {
          pictureImgElement.setAttribute('src', this.image);
        }
        if (this.imageAlt) {
          pictureImgElement.setAttribute('alt', this.imageAlt);
        }
      }
    } else {
      const imgElement = document.createElement('img');
      imgElement.src = this.image;
      imgElement.setAttribute('data-img', this.image);
      imgElement.setAttribute('alt', this.imageAlt);
      this.cardImageContainer.appendChild(imgElement);
    }

    this.cardTitle.innerHTML = `<p>${this.heading}</p>`;
    this.cardCta.innerHTML = this.ctaText;
    this.cardCta.href = this.link;

    // Event handlers
    this.cardImageLink.addEventListener("click", () => {
      this.trackGTM(this.image, this.link, this.ctaText);
    });

    this.cardCta.addEventListener("click", () => {
      this.trackGTM(this.image, this.link, this.ctaText);
    });
  }

  trackGTM(image, link, ctaText) {
    window.sendGTMData && window.sendGTMData({
      event: 'menu-card-image-click',
      source: 'menu-card-image',
      nav_bar_card_image: image,
      nav_bar_section_url: link,
      nav_bar_section_text: ctaText
    });
  }
});
